import { PieceAction } from '@apiContract';

export enum CombinedActions {
  CombinedPickUp = 1404,
  CombinedDelivery = 1408,
}

export type CommonAction = PieceAction | CombinedActions;

export type ValidationData = Record<number, { validatedByQrCode?: boolean; validationImageKey?: string }>;
